import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import './ComplexDateRangePicker.scss';

import CN from 'classnames';
import { enGB } from 'date-fns/locale';
import React, { FC, useState } from 'react';
import { createStaticRanges, DateRangePicker } from 'react-date-range';

import { Button } from '../Button';

export interface ComplexDateRangePickerProps {
  [x: string]: any;
  calendarFocus?: 'forwards' | 'backwards';
  className?: string;
  isEnableClearButton?: boolean;
  isEnableCloseButton?: boolean;
  isFooterButtons?: boolean;
  isRangesDisable?: boolean;
  isResponsive?: boolean;
  maxDate?: any;
  minDate?: any;
  isStaticRanges?: boolean;
  onChange?: any;
  onClear?: any;
  onClose?: any;
  selectedDate?: any;
  showDateDisplay?: boolean;
}
export const ComplexDateRangePicker: FC<ComplexDateRangePickerProps> = ({
  calendarFocus = 'backwards',
  className = undefined,
  isEnableClearButton = true,
  isEnableCloseButton = true,
  isFooterButtons = true,
  isRangesDisable = false,
  isResponsive = false,
  maxDate,
  minDate,
  isStaticRanges = false,
  onChange = undefined,
  onClear = undefined,
  onClose = undefined,
  selectedDate = undefined,
  showDateDisplay = true,
  ...restProps
}: ComplexDateRangePickerProps) => {
  const ComplexDateRangePickerClasses = CN(
    'complex-date-range-picker flex flex-col w-fit',
    className,
    {},
  );
  const [customRange, setCustomRange] = useState('');
  const state = [
    {
      startDate: selectedDate[0] ?? new Date(),
      endDate: selectedDate[1] ?? new Date(),
      key: 'selection',
    },
  ];
  const oneDayAgo = new Date(new Date().setDate(new Date().getDate() - 1));
  const thirtyDaysAgo = new Date(new Date().setDate(new Date().getDate() - 1));
  const staticRanges: any = [
    ...createStaticRanges([
      {
        label: 'Past 1 Day',
        range: () => ({
          startDate: oneDayAgo,
          endDate: new Date(),
          key: '1d',
        }),
        isSelected: () => {
          return customRange === '1d';
        },
      },
      {
        label: 'Past 30 Day',
        range: () => ({
          startDate: thirtyDaysAgo,
          endDate: new Date(),
          key: '30d',
        }),
        isSelected: () => {
          return customRange === '30d';
        },
      },
    ]),
  ];
  return (
    <div className={ComplexDateRangePickerClasses} {...restProps}>
      <DateRangePicker
        showPreview={false}
        onChange={(item) => {
          if (isStaticRanges) {
            setCustomRange(item?.selection?.key?.toString() || '');
          }
          onChange(item.selection);
        }}
        moveRangeOnFirstSelection={false}
        months={2}
        ranges={state}
        direction="horizontal"
        preventSnapRefocus
        calendarFocus={calendarFocus}
        color="#fffffff"
        locale={enGB}
        staticRanges={isStaticRanges ? staticRanges : undefined}
        inputRanges={isStaticRanges ? [] : undefined}
        showDateDisplay={showDateDisplay}
        maxDate={maxDate}
        minDate={minDate}
      />
      {isRangesDisable && (
        <style>{`
        .rdrDefinedRangesWrapper {
        display: none;
        }
      `}</style>
      )}
      {isResponsive && (
        <style>{`
        @media (max-width: 1024px) {
            .rdrMonths, .rdrMonthsHorizontal {
            display: flex;
            flex-direction: column;
            }
        }
        `}</style>
      )}
      {isFooterButtons && (
        <div className="flex justify-end gap-2 pr-[0.83rem] py-2">
          {/** close button */}
          {isEnableCloseButton && (
            <Button
              className="close-button w-[120px] justify-center"
              appearance="primary"
              onClick={() => {
                if (onClose) {
                  onClose();
                }
              }}
            >
              Select
            </Button>
          )}
          {isEnableClearButton && (
            <Button
              className="clear-button"
              appearance="primary"
              onClick={() => {
                if (onChange) {
                  onClear(state);
                }
              }}
            >
              Clear Values
            </Button>
          )}
        </div>
      )}
    </div>
  );
};
